export default __webpack_public_path__ + "static/media/benefits3New.878e54e1.gif";